// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#globe-container {
    width: 200%;
    height: 100%;
    left: -50%;
    position: relative;
    background: radial-gradient(circle, #07071d 40%, #111146 60%, #16165b 90%);
}

#globe-canvas {
    width: 100%;
    height: 100%;
    display: block;
}
`, "",{"version":3,"sources":["webpack://./src/Globe.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,0EAA0E;AAC9E;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB","sourcesContent":["#globe-container {\n    width: 200%;\n    height: 100%;\n    left: -50%;\n    position: relative;\n    background: radial-gradient(circle, #07071d 40%, #111146 60%, #16165b 90%);\n}\n\n#globe-canvas {\n    width: 100%;\n    height: 100%;\n    display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
